import { metrics } from '@seek/metrics-js';
import { useEffect } from 'react';

import { Page, PageSection, useTrackingClient } from 'src/context/tracking';

export function useTracking() {
  const client = useTrackingClient();

  useEffect(() => {
    client.setPage({
      pageTitle: Page.ROLE_REQUIREMENTS,
      currentPage: Page.ROLE_REQUIREMENTS,
    });

    client.trackView({
      view: Page.ROLE_REQUIREMENTS,
      currentPageSection: PageSection.EMPLOYER_QUESTIONS,
      eventName: ['apply_questions_displayed'],
    });

    metrics.count('APPLY_QUESTIONS_DISPLAYED');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
